import React from 'react';
import qs from 'qs';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import MarkdownPage from '../../components/MarkdownPage';
import docZH from './privacy-zh.md';
import docZHHant from './privacy-zh-hant.md';
import docEN from './privacy-en.md';
import docES from './privacy-es.md';

const Privacy = ({ location }) => {
  const search = qs.parse(location.search.slice(1));
  const docs = {
    cn: docZH,
    en: docEN,
    es: docES,
    'zh-Hant-HK': docZHHant,
  };
  const url = docs[search && search.locale] || docZH;
  return <MarkdownPage url={url} />;
};

Privacy.propTypes = {
  location: PropTypes.object.isRequired,
};

export default withRouter(Privacy);
